<template>
  <div class="create_company-wizard-buttons create_company-wizard-actions">
    <SecondaryButton
      v-if="showBack"
      label="Back"
      icon="bi bi-arrow-left"
      custom-class="create_company-wizard-btn"
      @click="$emit('back')"
    />
    <SecondaryButton
      v-if="showCancel"
      label="Cancel"
      icon="bi bi-x-lg"
      custom-class="create_company-wizard-btn"
      @click="$emit('cancel')"
    />
    <slot />
    <PrimaryButton
      :label="primaryLabel"
      icon=""
      custom-class="create_company-wizard-btn"
      @click="$emit('primary')"
    />
  </div>
</template>

<script>
import PrimaryButton from '@/modules/consultant/components/PrimaryButton.vue';
import SecondaryButton from '@/modules/consultant/components/SecondaryButton.vue';

export default {
  name: 'CreateCompanyWizardActions',
  components: {
    PrimaryButton,
    SecondaryButton,
  },
  props: {
    showBack: {
      type: Boolean,
      default: true,
    },
    showCancel: {
      type: Boolean,
      default: true,
    },
    primaryLabel: {
      type: String,
      default: 'Next',
    },
  },
  emits: ['back', 'cancel', 'primary'],
};
</script>
